import { createContext, useContext, useState, useEffect } from "react";

const translations = {
  es: {
    "nav.catalog": "Catálogo",
    "nav.cart": "Carrito",
    "nav.favorites": "Favoritos",
    "nav.admin": "Admin",
    "header.logout": "Salir",
    "header.logoutMobile": "Cerrar sesión",

    "login.title": "Iniciar sesión",
    "login.subtitle": "Acceso exclusivo para clientes registrados y aprobados.",
    "login.email": "Email",
    "login.password": "Contraseña",
    "login.emailPlaceholder": "usuario@empresa.com",
    "login.submit": "Ingresar",
    "login.submitting": "Ingresando...",
    "login.noAccount": "¿No tiene cuenta? El registro lo realiza el administrador. Contáctenos para solicitar acceso.",
    "login.slide1": "Moda al por mayor para tu negocio",
    "login.slide2": "Colecciones seleccionadas con calidad premium",
    "login.slide3": "Textiles de calidad, precios por docena",
    "login.slide4": "Variedad completa en tallas y colores",

    "pending.rejectedTitle": "Registro rechazado",
    "pending.pendingTitle": "Cuenta pendiente de aprobación",
    "pending.rejectedBody": "Su registro fue rechazado. Contacte al administrador para más información.",
    "pending.pendingBody": "Un administrador debe aprobar su registro antes de que pueda ver el catálogo y los precios.",
    "pending.logout": "Cerrar sesión",
    "app.loading": "Cargando...",
    "countdown.expired": "Acceso expirado",
    "countdown.title": "Tiempo de acceso restante",

    "catalog.title": "Catálogo",
    "catalog.searchPlaceholder": "Buscar por referencia o nombre...",
    "catalog.all": "Todas",
    "catalog.hide": "Ocultar",
    "catalog.viewAll": "Ver todas",
    "catalog.loading": "Cargando productos...",
    "catalog.empty": "No hay productos.",
    "catalog.emptyAdmin": "El administrador aún no ha importado el catálogo.",
    "product.add": "Agregar",
    "product.fav": "Agregar a favoritos", "product.unfav": "Quitar de favoritos", "catalog.favorites": "Favoritos", "product.favAdded": "guardado en favoritos", "product.favRemoved": "quitado de favoritos", "catalog.noFavs": "Aún no tienes favoritos. Toca el corazón de un producto para guardarlo.", "fav.allToCart": "Agregar todos al carrito", "fav.exportPdf": "Exportar PDF", "fav.addedToCart": "favoritos agregados al carrito", "fav.pdfOk": "Lista de favoritos descargada",
    "product.boxes": "cajas",
    "product.packingNA": "Empaque N/D", "product.size": "Tamaño", "product.reference": "Referencia", "product.packing": "Empaque", "product.price": "Precio",
    "product.inCart": "En carrito:",
    "toast.added": "agregadas al carrito",
    "toast.sentTo": "enviada a",
    "toast.pdfGenerated": "Proforma PDF generada",

    "cart.title": "Carrito",
    "cart.clear": "Vaciar carrito",
    "cart.empty": "Su carrito está vacío.", "cart.outOfStockWarn": "Hay productos agotados en su carrito. Elimínelos para poder generar la proforma.", "cart.removeOos": "Quitar agotados del carrito", "cart.removedOos": "producto(s) agotado(s) eliminado(s)", "fav.notePh": "Nota: color, talla, comentario…", "fav.noteSaved": "nota guardada", "product.outOfStock": "AGOTADO", "fav.notifyMe": "Avísame cuando vuelva", "fav.notifyOn": "Te avisaremos por correo", "fav.notifyOk": "Te avisaremos cuando vuelva a estar disponible", "fav.notifyOff": "Aviso cancelado",
    "cart.product": "Producto",
    "cart.boxes": "Cajas",
    "cart.totalQty": "Cantidad total",
    "cart.pricePer": "Precio/ud",
    "cart.total": "Total",
    "cart.packingNA": "empaque N/D",
    "cart.notesLabel": "Notas / instrucciones de entrega (opcional)",
    "cart.notesPlaceholder": "Ej: Entregar en bodega principal, horario de 8am a 3pm...",
    "cart.grandTotal": "Gran Total",
    "cart.traspasoLabel": "TRASPASO",
    "cart.marcaLabel": "MARCA",
    "cart.traspaso": "Traspaso",
    "cart.sendEmail": "Enviar por Email",
    "cart.sending": "Enviando...",
    "cart.generatePdf": "Generar Proforma PDF",
    "cart.generating": "Generando...",

    "admin.title": "Panel de Administración",
    "admin.tab.users": "Usuarios",
    "admin.tab.requests": "Solicitudes",
    "admin.tab.products": "Productos",
    "admin.tab.incomplete": "Incompletos",
    "admin.tab.proformas": "Proformas",
    "admin.tab.stats": "Estadísticas",
    "admin.tab.emails": "Correos",
    "admin.tab.import": "Importar Drive",
    "admin.tab.settings": "Ajustes",
  },
  en: {
    "nav.catalog": "Catalog",
    "nav.cart": "Cart",
    "nav.favorites": "Favorites",
    "nav.admin": "Admin",
    "header.logout": "Log out",
    "header.logoutMobile": "Log out",

    "login.title": "Sign in",
    "login.subtitle": "Exclusive access for registered and approved clients.",
    "login.email": "Email",
    "login.password": "Password",
    "login.emailPlaceholder": "user@company.com",
    "login.submit": "Sign in",
    "login.submitting": "Signing in...",
    "login.noAccount": "No account? Registration is handled by the administrator. Contact us to request access.",
    "login.slide1": "Wholesale fashion for your business",
    "login.slide2": "Curated collections with premium quality",
    "login.slide3": "Quality textiles, prices per dozen",
    "login.slide4": "Full variety in sizes and colors",

    "pending.rejectedTitle": "Registration rejected",
    "pending.pendingTitle": "Account pending approval",
    "pending.rejectedBody": "Your registration was rejected. Contact the administrator for more information.",
    "pending.pendingBody": "An administrator must approve your registration before you can view the catalog and prices.",
    "pending.logout": "Log out",
    "app.loading": "Loading...",
    "countdown.expired": "Access expired",
    "countdown.title": "Remaining access time",

    "catalog.title": "Catalog",
    "catalog.searchPlaceholder": "Search by reference or name...",
    "catalog.all": "All",
    "catalog.hide": "Hide",
    "catalog.viewAll": "View all",
    "catalog.loading": "Loading products...",
    "catalog.empty": "No products.",
    "catalog.emptyAdmin": "The administrator hasn't imported the catalog yet.",
    "product.add": "Add",
    "product.fav": "Add to favorites", "product.unfav": "Remove from favorites", "catalog.favorites": "Favorites", "product.favAdded": "saved to favorites", "product.favRemoved": "removed from favorites", "catalog.noFavs": "No favorites yet. Tap the heart on a product to save it.", "fav.allToCart": "Add all to cart", "fav.exportPdf": "Export PDF", "fav.addedToCart": "favorites added to cart", "fav.pdfOk": "Favorites list downloaded",
    "product.boxes": "boxes",
    "product.packingNA": "Packing N/A", "product.size": "Size", "product.reference": "Reference", "product.packing": "Packing", "product.price": "Price",
    "product.inCart": "In cart:",
    "toast.added": "added to cart",
    "toast.sentTo": "sent to",
    "toast.pdfGenerated": "Proforma PDF generated",

    "cart.title": "Cart",
    "cart.clear": "Empty cart",
    "cart.empty": "Your cart is empty.", "cart.outOfStockWarn": "Some products in your cart are out of stock. Remove them to generate the proforma.", "cart.removeOos": "Remove out-of-stock items", "cart.removedOos": "out-of-stock item(s) removed", "fav.notePh": "Note: color, size, comment…", "fav.noteSaved": "note saved", "product.outOfStock": "OUT OF STOCK", "fav.notifyMe": "Notify me when back", "fav.notifyOn": "We'll email you", "fav.notifyOk": "We'll notify you when it's back in stock", "fav.notifyOff": "Alert cancelled",
    "cart.product": "Product",
    "cart.boxes": "Boxes",
    "cart.totalQty": "Total quantity",
    "cart.pricePer": "Price/unit",
    "cart.total": "Total",
    "cart.packingNA": "packing N/A",
    "cart.notesLabel": "Notes / delivery instructions (optional)",
    "cart.notesPlaceholder": "E.g.: Deliver to main warehouse, 8am to 3pm...",
    "cart.grandTotal": "Grand Total",
    "cart.traspasoLabel": "TRANSFER",
    "cart.marcaLabel": "BRAND",
    "cart.traspaso": "Transfer",
    "cart.sendEmail": "Send by Email",
    "cart.sending": "Sending...",
    "cart.generatePdf": "Generate Proforma PDF",
    "cart.generating": "Generating...",

    "admin.title": "Administration Panel",
    "admin.tab.users": "Users",
    "admin.tab.requests": "Requests",
    "admin.tab.products": "Products",
    "admin.tab.incomplete": "Incomplete",
    "admin.tab.proformas": "Proformas",
    "admin.tab.stats": "Statistics",
    "admin.tab.emails": "Emails",
    "admin.tab.import": "Import Drive",
    "admin.tab.settings": "Settings",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "es");
  useEffect(() => { localStorage.setItem("lang", lang); }, [lang]);
  const t = (key) => (translations[lang] && translations[lang][key]) || translations.es[key] || key;
  const toggle = () => setLang((l) => (l === "es" ? "en" : "es"));
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
